import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementHintSecurityIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 27 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<g clipPath="url(#clip0_7583_31373)">
				<path
					d="M0 3C0 1.3 1.3 0 3 0H24C25.7 0 27 1.3 27 3V15C27 16.7 25.7 18 24 18H3C1.3 18 0 16.7 0 15V3Z"
					fill="#E6E9EB"
				/>
				<path fillRule="evenodd" clipRule="evenodd" d="M4 12H23V14H4V12Z" fill="#B9C4C9" />
				<path
					d="M5 4H7C7.6 4 8 4.4 8 5V7C8 7.6 7.6 8 7 8H5C4.4 8 4 7.6 4 7V5C4 4.4 4.4 4 5 4Z"
					fill="white"
				/>
				<path
					d="M19 4.5H21C22.4 4.5 23.5 5.6 23.5 7C23.5 8.4 22.4 9.5 21 9.5H19C17.6 9.5 16.5 8.4 16.5 7C16.5 5.6 17.6 4.5 19 4.5Z"
					stroke="#B2231E"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7583_31373">
					<rect width="27" height="18" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

PaiementHintSecurityIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementHintSecurityIcon;
